import { Button, Stack, Typography } from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers';
import { AUDIT_LOGS_TEST_IDS } from 'pages/AuditLogs/AuditLogs.testIds';
import { AuditLogExportDateRangeProps } from './AuditLogExportDateRange.props';

const AuditLogExportDateRange = ({
  endDate,
  hasInvalidRange,
  onEndDateChange,
  onStartDateChange,
  startDate,
}: AuditLogExportDateRangeProps) => (
  <Stack spacing={2}>
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <Stack spacing={0.5} sx={{ flex: 1 }}>
        <DateTimePicker
          label="Start date and time"
          value={startDate}
          onChange={onStartDateChange}
          slotProps={{
            textField: {
              fullWidth: true,
              inputProps: { 'data-testid': AUDIT_LOGS_TEST_IDS.exportStartDateInput },
            },
          }}
        />
        <Button size="small" onClick={() => onStartDateChange(null)} sx={{ alignSelf: 'flex-start' }}>
          Clear start
        </Button>
      </Stack>
      <Stack spacing={0.5} sx={{ flex: 1 }}>
        <DateTimePicker
          label="End date and time"
          value={endDate}
          onChange={onEndDateChange}
          slotProps={{
            textField: { fullWidth: true, inputProps: { 'data-testid': AUDIT_LOGS_TEST_IDS.exportEndDateInput } },
          }}
        />
        <Button size="small" onClick={() => onEndDateChange(null)} sx={{ alignSelf: 'flex-start' }}>
          Clear end
        </Button>
      </Stack>
    </Stack>
    {!startDate && <Typography color="error">A start date and time is required.</Typography>}
    {hasInvalidRange && <Typography color="error">The start date must be before the end date.</Typography>}
  </Stack>
);

export default AuditLogExportDateRange;
